export const BCRYPT_SALT = `${process.env.REACT_APP_BCRYPT_KEY}`;
